<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back"
        class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto" role="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Text Area</h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>
<div class="content content--text-area">
  <ng-container *ngIf="isBrowser;else noJsContent">
    <h2>TextArea Use Case 1 : ngModel</h2>
    <maced-text-area textAreaId="textAreaId1" name="textAreaId1" label="Text Area Field" placeholder="Text Area Field"
      [maxLength]="maxLength" [(ngModel)]="textAreaNgModel">
    </maced-text-area>
    <p>
      Result:- {{ textAreaNgModel }}
    </p>

    <h2>TextArea Use Case 2 : Form Control</h2>
    <maced-text-area textAreaId="textAreaId2" name="textAreaId2" label="Text Area Field" placeholder="Text Area Field"
      [maxLength]="maxLength" [formControl]="textAreaFormControl">
      <ng-container ngProjectAs="[message]">
        <div class="c-input-group__help-text" role="alert">
          This is helper text
        </div>
      </ng-container>
    </maced-text-area>
    <p>
      Result:- {{ textAreaFormControl.value }}
    </p>

    <h2>TestArea Use Case 3 : Angular Form</h2>
    <form [formGroup]="form" (ngSubmit)="submitted=true" id="form1">
      <div class="content__textarea">
        <maced-text-area textAreaId="textAreaId3" name="textAreaId3" label="Text Area Field" formId="form1"
          placeholder="Text Area Field" [maxLength]="maxLength" [required]="true" formControlName="textArea"
          [hasError]="(form.controls.textArea.touched || submitted) && !!form.controls.textArea.errors">
          <ng-container ngProjectAs="[message]">
            <div class="c-input-group__error" role="alert"
              *ngIf="(form.controls.textArea.touched || submitted) && form.controls.textArea.errors?.required">
              This field is required
            </div>
            <div class="c-input-group__error" role="alert"
              *ngIf="(form.controls.textArea.touched || submitted) && form.controls.textArea.errors?.pattern">
              Allows Alphabets
            </div>
          </ng-container>
        </maced-text-area>
      </div>
      <div class="u-mt-16">
        <maced-button buttonId="submit1" label="Submit" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>
      Result:- {{ form.value.textArea }}
    </p>

    <h2>TextArea Use Case 4 : Disabled State</h2>
    <maced-text-area textAreaId="textAreaId4" name="textAreaId4" label="Text Area Field" placeholder="Text Area Field"
      [maxLength]="maxLength" [disabled]="true" [(ngModel)]="textAreaDisabledNgModel">
    </maced-text-area>

    <h2>TextArea Use Case 5 : TextArea with character count message</h2>
    <maced-text-area textAreaId="textAreaId5" name="textAreaId5" label="Student's Book" placeholder="Write your feedback..."
      [maxLength]="maxLength" [(ngModel)]="textAreaNgModel" [hasExceedingTextAlert]="true"
      exceedingTextMessage="The maximum number of characters has been reached.">
    </maced-text-area>
  </ng-container>

  <ng-template #noJsContent>
    <h2>With Form</h2>
    <form action="/text-area" method="get" id="form2">
      <maced-text-area textAreaId="textAreaId5" name="textAreaId5" label="Text Area Field" placeholder="Text Area Field"
        [maxLength]="maxLength" [value]="textAreaId5" formId="form2">
      </maced-text-area>
      <div class="u-mt-16">
        <maced-button buttonId="submit2" label="Submit" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>
      Result:- {{ textAreaId5 }}
    </p>
    <h2>Without Form</h2>
    <form action="/text-area" method="get">
      <maced-text-area textAreaId="textAreaId6" name="textAreaId6" label="Text Area Field" placeholder="Text Area Field"
        [maxLength]="maxLength" [value]="textAreaId6">
      </maced-text-area>
      <div class="u-mt-16">
        <maced-button buttonId="submit3" label="Submit" buttonType="submit"></maced-button>
      </div>
    </form>
    <p>
      Result:- {{ textAreaId6 }}
    </p>
  </ng-template>
</div>